import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';
import { CrmPaymentsSideBarFilterType } from '../side-bar-filter/crm-payments-side-bar-filter.type';
import { CrmPaymentsReportRow } from '../../../../../api/types/reports/finance/crm-payments-report.type';

export const getCrmPaymentsReportOperation = async (
  filters: CrmPaymentsSideBarFilterType,
  offset: number,
  limit: number,
  setData: (data: CrmPaymentsReportRow[]) => any,
  setTotal: (total: number) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getCrmPaymentsReport({
      branchIds: filters.branchIds ?? [],
      unassignBranch: filters.unassignBranch ?? true,
      paymentMethods: filters.paymentMethods ?? [],
      startFrom: filters.startFrom ?? null,
      toDate: filters.toDate ?? null,
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
